var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img",domProps:{"innerHTML":_vm._s(_vm.svgContent)}})
}
var staticRenderFns = []

export { render, staticRenderFns }